/**
 * @generated SignedSource<<42d69037eb7402a75961a7a7d60f9a56>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type GeneratedProblemActionEnum = "generated_problem_activate" | "generated_problem_deactivate" | "%future added value";
export type GeneratedProblemStatusEnum = "active" | "inactive" | "%future added value";
export type GeneratedProblemDeactivateInput = {
  id: string;
};
export type ProblemGeneratorGeneratedProblemMutationActionsDialog_generatedProblemDeactivateMutation$variables = {
  input: GeneratedProblemDeactivateInput;
};
export type ProblemGeneratorGeneratedProblemMutationActionsDialog_generatedProblemDeactivateMutation$data = {
  readonly generatedProblemDeactivate: {
    readonly actions: ReadonlyArray<GeneratedProblemActionEnum>;
    readonly id: string;
    readonly status: GeneratedProblemStatusEnum;
  };
};
export type ProblemGeneratorGeneratedProblemMutationActionsDialog_generatedProblemDeactivateMutation = {
  response: ProblemGeneratorGeneratedProblemMutationActionsDialog_generatedProblemDeactivateMutation$data;
  variables: ProblemGeneratorGeneratedProblemMutationActionsDialog_generatedProblemDeactivateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "GeneratedProblem",
    "kind": "LinkedField",
    "name": "generatedProblemDeactivate",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "actions",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ProblemGeneratorGeneratedProblemMutationActionsDialog_generatedProblemDeactivateMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ProblemGeneratorGeneratedProblemMutationActionsDialog_generatedProblemDeactivateMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "0385748260b7446380217b909067ce85",
    "id": null,
    "metadata": {},
    "name": "ProblemGeneratorGeneratedProblemMutationActionsDialog_generatedProblemDeactivateMutation",
    "operationKind": "mutation",
    "text": "mutation ProblemGeneratorGeneratedProblemMutationActionsDialog_generatedProblemDeactivateMutation(\n  $input: GeneratedProblemDeactivateInput!\n) {\n  generatedProblemDeactivate(input: $input) {\n    id\n    status\n    actions\n  }\n}\n"
  }
};
})();

(node as any).hash = "df90eedba4b430c4a2bc2b02aaa73998";

export default node;
